import { GenericBackendResponse } from '../genericBackendResponse';

export interface PensionPlanCatalogItem {
	id: string;
	name: string;
	displayName: string;
	fundNames: string[];
	managerName: string;
	promoterName: string;
	type: string;
	return1Y: number | null;
	return3Y: number | null;
	return5Y: number | null;
	commissionManagement: string | null;
	invercoCode: string;
	dgsfpCode: string;
	notes: string;
	isActive: boolean;
}

/**
 * 🔴 Con la sesión del usuario, nunca con `x-password`: la contraseña compartida de la API
 * iría dentro del bundle público y cualquiera podría leerla.
 */
const getCatalogPlanBySlug = async (
	slug: string,
	token: string
): Promise<GenericBackendResponse<PensionPlanCatalogItem>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-catalog/by-name/${slug}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error(`getCatalogPlanBySlug failed: ${response.status}`);
	}

	return response.json();
};

export default getCatalogPlanBySlug;
